import React from 'react';

const badgeStyle = { fontSize: '0.8rem', padding: '6px 10px' };

export default function FteMonthSelector({ year, month, onChangeMonth }) {
  return (
    <span className='badge bg-light text-dark border' style={{ ...badgeStyle, padding: 0 }}>
      <button
        className='btn btn-sm btn-outline-primary border-0'
        onClick={() => onChangeMonth(-1)}
        title='Previous month'
        style={{ borderRadius: '4px 0 0 4px', padding: '4px 8px' }}
      >
        <i className='fa-solid fa-chevron-left'></i>
      </button>
      <span className='fw-bold' style={{ padding: '0 12px' }}>
        {year}/{String(month).padStart(2, '0')}
      </span>
      <button
        className='btn btn-sm btn-outline-primary border-0'
        onClick={() => onChangeMonth(1)}
        title='Next month'
        style={{ borderRadius: '0 4px 4px 0', padding: '4px 8px' }}
      >
        <i className='fa-solid fa-chevron-right'></i>
      </button>
    </span>
  );
}
